import React, {
  PropsWithChildren,
  useContext,
  Dispatch,
  useReducer,
} from "react";

export type ViewType = "tree" | "ecgs";

export type Support = {
  show: boolean;
  subject?: string;
  description?: string;
};

interface IMainContextState {
  selectedViewType: ViewType;
  support: Support;
}

export enum MainContextActionType {
  SET_VIEW_TYPE = "SET_VIEW_TYPE",
  SET_SHOW_SUPPORT = "SET_SHOW_SUPPORT",
}

type MainContextReducerAction =
  | {
      type: MainContextActionType.SET_VIEW_TYPE;
      payload: ViewType;
    }
  | {
      type: MainContextActionType.SET_SHOW_SUPPORT;
      payload: Support;
    };
interface IMainContext {
  state: IMainContextState;
  dispatch: Dispatch<MainContextReducerAction>;
}

const initState: IMainContextState = {
  selectedViewType: "ecgs",
  support: { show: false },
};

const MainContext = React.createContext<IMainContext>({
  state: initState,
  dispatch: () => {},
});

const mainContextReducer = (
  state: IMainContextState,
  action: MainContextReducerAction
): IMainContextState => {
  switch (action.type) {
    case MainContextActionType.SET_VIEW_TYPE:
      return { ...state, selectedViewType: action.payload };
    case MainContextActionType.SET_SHOW_SUPPORT:
      return { ...state, support: action.payload };
    default:
      return state;
  }
};

export const MainContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const [state, dispatch] = useReducer(mainContextReducer, initState);

  return (
    <MainContext.Provider value={{ state, dispatch }}>
      {children}
    </MainContext.Provider>
  );
};

export const useMainContext = () => useContext(MainContext);
